<template>  
  <v-layout class="map-container"  v-resize="updateSize">    
    <!-- <map-control uiid="map_picker" hide-glider-section /> -->
    <map-picker ref="map" uiid="map_picker" maptype="picker" v-model="latLng"></map-picker>      
  </v-layout>  
</template>
<script lang="ts">        
  import Vue from 'vue'  
  import Component from 'vue-class-component'  
  import MapPicker from '@/components/map/Map.vue'
  import MapControl from '@/components/map/MapControl.vue'

  @Component({
    name: 'LatLngField',  
    props:{                          
      value:{
        type:Array,
        default:[0,0]
      }
    },
    components:{MapPicker,MapControl}
  })
  export default class LatLngField extends Vue {  
        
    private value!:Array<number>
    
    mounted() {          
      setTimeout(() => this.updateSize(),2000)
    }

    get latLng(){
      return this.value
    }
    set latLng(newV){
      this.$emit('input',newV)
    }

    updateSize() {        
      if(!this.$refs.map) this.$nextTick(this.updateSize)
      //@ts-ignore
      else this.$refs.map.updateSize()            
    } 
  
  }
</script>
